module.exports = __webpack_public_path__ + "static/img/8_he.fd5876a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/8_he.png
// module id = weoJ
// module chunks = 0